export const state = {
  // HTTP response properties
  httpText: "",
  httpColor: "",
  httpIsActive: false,

  // Simple error management
  currentError: null
};

export const getters = {
  httpText: state => state.httpText,
  httpColor: state => state.httpColor,
  httpIsActive: state => state.httpIsActive,
  currentError: state => state.currentError
};

export const mutations = {
  SET_HTTP_RESPONSE(state, data) {
    state.httpText = data.text;
    state.httpColor = data.color;
    state.httpIsActive = true;
  },
  RESET_HTTP_RESPONSE(state) {
    state.httpIsActive = false;
  }
};

export const actions = {
  setHttpResponse({ commit, dispatch }, payload) {
    if (payload.text) {
      commit("SET_HTTP_RESPONSE", payload);
      setTimeout(() => {
        dispatch("resetHttpResponse");
      }, 3000);
    }
  },
  resetHttpResponse({ commit }) {
    commit("RESET_HTTP_RESPONSE");
  }
};
